export var RestoreTemplateResourceType;
(function (RestoreTemplateResourceType) {
    RestoreTemplateResourceType["RESTORE_TEMPLATE_RESOURCE_TYPE_UNSPECIFIED"] = "RESTORE_TEMPLATE_RESOURCE_TYPE_UNSPECIFIED";
    RestoreTemplateResourceType["RESTORE_TEMPLATE_RESOURCE_TYPE_EC2_INSTANCE"] = "EC2_INSTANCE";
    RestoreTemplateResourceType["RESTORE_TEMPLATE_RESOURCE_TYPE_S3_BUCKET"] = "S3_BUCKET";
})(RestoreTemplateResourceType || (RestoreTemplateResourceType = {}));
